// The tailoring run currently open in this tab. Every stage call sends these
// fields so the server's cost ledger (public.ai_usage_log) can total the run.
export interface LedgerRun { runId: string; runLabel: string }

let current: LedgerRun | null = null;

export function startLedgerRun(label: string): LedgerRun {
  const runId = globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  current = { runId, runLabel: label.slice(0, 200) };
  return current;
}

export function setLedgerRun(run: LedgerRun | null): void {
  current = run;
}

export function ledgerRunFields(): { run_id?: string; run_label?: string } {
  return current ? { run_id: current.runId, run_label: current.runLabel } : {};
}
